import { uiText, useUiLanguage } from '../../../utils/uiTranslation';
import React from 'react';
import { ANALYTICS_GRAPH_TYPES } from './graphCatalog';

const FunnelVisual = ({ model }) => {
  useUiLanguage();
  const dataset = model.dataset;
  const stages = dataset?.stages || [];
  if (!stages.length) return null;
  const maxCount = Math.max(...stages.map((stage) => stage.count), 1);

  if (model.activeGraph === ANALYTICS_GRAPH_TYPES.HORIZONTAL_BAR) {
    return (
      <div className="analytics-visual analytics-visual-funnel-bars">
        {stages.map((stage) => (
          <div key={stage.id} className="analytics-visual-bar-row">
            <div className="analytics-visual-row-head">
              <span className="analytics-visual-label">{uiText(stage.label)}</span>
              <div className="analytics-visual-row-metrics">
                <strong className="analytics-visual-number">{stage.conversionRate.toFixed(1)}%</strong>
                <span className="analytics-visual-sub">{stage.count.toLocaleString()}</span>
              </div>
            </div>
            <div className="analytics-visual-track">
              <div className={`analytics-visual-fill ${stage.tone || 'accent'}`} style={{ width: `${(stage.count / maxCount) * 100}%` }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (model.activeGraph === ANALYTICS_GRAPH_TYPES.FUNNEL_WATERFALL) {
    return (
      <div className={`analytics-visual analytics-visual-funnel-classic analytics-visual-funnel-waterfall ${model.size}`}>
        {stages.map((stage, index) => {
          const width = Math.max(18, (stage.count / maxCount) * 100);
          return (
            <div key={stage.id} className="analytics-visual-funnel-classic-row">
              <div className="analytics-visual-funnel-classic-labels">
                <span className="analytics-visual-label">{uiText(stage.label)}</span>
              </div>
              <div className="analytics-visual-funnel-classic-track">
                <div className="analytics-visual-funnel-classic-lane">
                  <div className="analytics-visual-funnel-classic-shell" style={{ width: `${width}%` }}>
                    <div className={`analytics-visual-funnel-classic-bar ${stage.tone || 'accent'}`}>
                      <strong className="analytics-visual-number">{stage.count.toLocaleString()}</strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="analytics-visual-funnel-classic-metrics">
                <strong className="analytics-visual-number">{stage.conversionRate.toFixed(1)}%</strong>
                {index === 0 ? (
                  <span className="analytics-visual-sub">{uiText("Baseline")}</span>
                ) : stage.dropoffCount ? (
                  <span className={`analytics-visual-sub ${stage.tone === 'success' ? 'success' : stage.tone === 'warning' ? 'warning' : stage.tone === 'danger' ? 'danger' : ''}`}>
                    -{stage.dropoffCount.toLocaleString()} · {stage.dropoffRate.toFixed(1)}%
                  </span>
                ) : (
                  <span className="analytics-visual-sub">{uiText("Final stage")}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  if (model.activeGraph === ANALYTICS_GRAPH_TYPES.SANKEY_FLOW) {
    return (
      <div className="analytics-visual analytics-visual-funnel-sankey">
        {stages.map((stage, index) => (
          <div key={stage.id} className="analytics-visual-sankey-stage">
            <div className={`analytics-visual-sankey-node ${stage.tone || 'accent'}`}>
              <span className="analytics-visual-label">{uiText(stage.label)}</span>
              <strong className="analytics-visual-number">{stage.count.toLocaleString()}</strong>
            </div>
            {index < stages.length - 1 ? (
              <div className="analytics-visual-sankey-link">
                <div className="analytics-visual-sankey-link-line" style={{ width: `${Math.max(stages[index + 1].conversionRate, 10)}%` }} />
                <span className="analytics-visual-sub">-{stages[index + 1].dropoffCount.toLocaleString()} · {stages[index + 1].dropoffRate.toFixed(1)}%</span>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`analytics-visual analytics-visual-funnel-classic ${model.size}`}>
      {stages.map((stage, index) => {
        const width = Math.max(22, (stage.count / maxCount) * 100);
        return (
          <div key={stage.id} className="analytics-visual-funnel-classic-row">
            <div className="analytics-visual-funnel-classic-labels">
              <span className="analytics-visual-label">{uiText(stage.label)}</span>
            </div>
            <div className="analytics-visual-funnel-classic-track">
              <div className="analytics-visual-funnel-classic-lane">
                <div className="analytics-visual-funnel-classic-shell" style={{ width: `${width}%` }}>
                  <div className={`analytics-visual-funnel-classic-bar ${stage.tone || 'accent'}`}>
                    <strong className="analytics-visual-number">{stage.count.toLocaleString()}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div className="analytics-visual-funnel-classic-metrics">
              <strong className="analytics-visual-number">{stage.conversionRate.toFixed(1)}%</strong>
              {index === 0 ? (
                <span className="analytics-visual-sub">{uiText("Baseline")}</span>
              ) : stage.dropoffCount ? (
                <span className="analytics-visual-sub">{uiText("Drop-off ")}{stage.dropoffCount.toLocaleString()} · {stage.dropoffRate.toFixed(1)}%
                </span>
              ) : (
                <span className="analytics-visual-sub">{uiText("Final stage")}</span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelVisual;
